import { Pipe, PipeTransform } from '@angular/core';
import { CustomFieldType } from '../../../models/metadata';

@Pipe({
  name: 'customFieldType',
  standalone: true
})
export class CustomFieldTypePipe implements PipeTransform {
  private readonly typeToLabelMap = new Map<CustomFieldType, string>([
    ['Internal', 'Internal field'],
    ['ExternalEdit', 'External edit field'],
    ['ExternalRead', 'External read field']
  ]);

  transform(type: CustomFieldType): string {
    return this.typeToLabelMap.get(type) || '';
  }
}
